import type { StudentExtendedPersona } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getExtendedStudentPersona(studentNo: string) {
    try {
        const result = await portalApi.get<StudentExtendedPersona>(`/students/${studentNo}/extended-persona`);
        return result.data;
    } catch (error) {
        console.error("Error fetching extended student persona:", error);
        throw error;
    }
}
